import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "../../context/TranslationContext";
import { FaSpinner, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { baseurl } from "../../helper/Baseurl";
import ShiekhCard from "../../component/Shiekh/ShiekhCard";
import ShiekhModal from "../../models/ShiekhModal";
export default function Shiek() {
  const { translations, language } = useTranslation();
  const isArabic = language === "ar";


  const [sheikhs, setSheikhs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [sheikhDetails, setSheikhDetails] = useState([]);
  const [sheikhInfo, setSheikhInfo] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    const fetchSheikhs = async () => {
      try {
        const { data } = await axios.get(`${baseurl}public/sheikh`);
        setSheikhs(data);
      } catch (err) {
        console.error("Error fetching Sheikhs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSheikhs();
  }, []);

  const totalPages = Math.ceil(sheikhs.length / itemsPerPage);
  const paginatedSheikhs = sheikhs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDetailsClick = async (id) => {
    try {

      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // Fetch Sheikh Info
      const [infoRes, historyRes] = await Promise.all([
        axios.get(`${baseurl}sheikhs/${id}`, { headers }),
        axios.get(`${baseurl}sheikh-center-histories/sheikh/${id}`, { headers }),
      ]);

      setSheikhInfo(infoRes.data);
      setSheikhDetails(historyRes.data);

      setModalOpen(true);
    } catch (err) {
      console.error("Error fetching Sheikh details:", err);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <FaSpinner className="text-4xl animate-spin" />
      </div>
    );
  }
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <FaSpinner className="text-4xl animate-spin" />
      </div>
    );
  }

  return (
    <>
    <div className={`flex ${isArabic ? "flex-col md:flex-row" : "flex-col-reverse md:flex-row-reverse"} pt-24 w-full`}>
      <div className="container mx-auto px-4 py-6" style={{ fontFamily: "Tajwal, sans-serif", direction: isArabic ? "rtl" : "ltr", textAlign: isArabic ? "right" : "left" }}>
        <h1 className="text-xl font-bold mb-1">{translations.shiekhsListTitle}</h1>
        <hr className="my-2 border-gray-200" />
        <div className="flex items-center w-full">
          <input
            type="text"
            placeholder={translations.searchPlaceholder}
            className="p-2 border rounded-md w-full mr-4"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
          {paginatedSheikhs.map((shiekh) => (
            <ShiekhCard key={shiekh.id} shiekh={shiekh} handleClick={handleDetailsClick} />
          ))}
        </div>

        <div className="mt-4">
          <ul className="flex justify-center items-center space-x-2">
            <li>
              <button
                className="px-3 py-1 rounded-full text-primary-blue"
                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {isArabic ? <FaArrowRight /> : <FaArrowLeft />}
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  className={`px-3 py-1 rounded-full ${currentPage === index + 1 ? "bg-primary-blue text-white" : "text-gray-700"}`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                className="px-3 py-1 rounded-full text-primary-blue"
                onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {isArabic ? <FaArrowLeft /> : <FaArrowRight />}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <ShiekhModal
      modalOpen={modalOpen}
      shiekhInfo={sheikhInfo}
      shiekhDetails={sheikhDetails}
      onClose={() => setModalOpen(false)}
      translations={translations}
    />
  </>
  );
}
